<script lang="ts">
	import { fade } from 'svelte/transition';
	import Image from "svelte-image";
	import { productScore, tierScore } from './stores';
	import TierQuiz from './components/TierQuiz.svelte';
	import ProductQuiz from './components/ProductQuiz.svelte';
	import type { Product, QuizAttempt } from 'lib/interfaces';
	import { onMount } from 'svelte';
import { API_END_POINT } from 'lib/utils';
  
	let section = 0;
	let intro = true;
	let quizAttempt = false;
	let quizAttemptData = [];
	$: sectionRecommended = (section === 3);
	$: if (sectionRecommended) {
	  const products = results;
	  products.forEach(product => {
		saveToDB(product);
	  })
	}
  
	setTimeout(() => intro = false, 5900);
  
	$: results = [...$productScore].sort((a, b) => a.score == b.score ? 0 : (a < b ? -1 : 1)).slice(0, $tierScore.reduce((previous, current, index, array) => current >= array[previous] ? index : previous, 0) + 1);
  
	$: if (results.includes($productScore[2]) && results.includes($productScore[5])) {
	  results = [...$productScore].sort((a, b) => a.score == b.score ? 0 : (a < b ? -1 : 1)).slice(0, $tierScore.reduce((previous, current, index, array) => current >= array[previous] ? index : previous, 0) + 2);
  
	  if (results.indexOf($productScore[2]) > results.indexOf($productScore[5]))
		results = results.filter(product => product.name != 'Time for Bed');
	  else
		results = results.filter(product => product.name != 'The Basics');
	}
  
  
  
	const saveToDB = (product: Product) => {
	  fetch(`${API_END_POINT}/add-user-product?productId=${product.id}`, {
		credentials: "include"
	  })
	  .then((response) => response.text())
	  .then((result) => {
		console.log(result);
	  });
	}
  
	const checkQuizAttempt = () => { 
	  fetch(`${API_END_POINT}/quiz-attempt`, {
		credentials: "include"
	  })
	  .then((response) => response.json())
	  .then((_result) => {
		console.log(_result);
		if(_result.message === "success") {
		  quizAttempt = true;
		  // save attempted quiz data
		  const quizAttemptObj: QuizAttempt[] = JSON.parse(_result.main);
		  results = [];
		  quizAttemptObj.forEach(quizAttempt => {
			const filteredProducts = $productScore.filter(product => product.id === quizAttempt.Product_ID);
			//quizAttemptData.push(filteredProducts[0]);
			results.push(filteredProducts[0]);
		  });
		}
	  });
	}
  
	const startNewSession = () => {
		fetch(`${API_END_POINT}/start-new-session`, {
			credentials: "include"
		})
		.then((response) => response.json())
		.then((_result: any) => {
			console.log(_result);
			quizAttempt = false;
	  		section = 0;
		});
	}

	const verifySesssion = () => {
		fetch(`${API_END_POINT}`, {
			credentials: "include"
		})
		.then((response) => response.json())
		.then((_result: any) => {
			console.log(_result);
			if(_result.message === "The User is verified!") {
				checkQuizAttempt();
			}
		});
	}

	onMount(() => {
		verifySesssion();
	});
  
	
  
  </script>
  
  {#if intro}
  <img
	src='/images/intro.gif'
	alt='Intro animation depicting the company logo: a C surrounded by a laurel open on the right.'
  />
  {:else if quizAttempt}
	<div class="container-quiz-attempt">
	  <h1>Want to see your results again?</h1>
	  
	  <div>
		<button on:click={() => {quizAttempt=false;section=4;}}>
		  See Results!
		</button>
	  </div>
	  <br>
	  <div>
		<button on:click={() => startNewSession()}>
			Take The Quiz Again
		</button>
	  </div>
	</div>
	<footer>
	  <Image
		src='/images/transparent-logo.png'
		alt='Catharsis Skincare Co logo depicting the letter C surrounded by a laurel.'
	  />
	</footer>
  {:else}
  <main transition:fade>
	<div class="container-content">
	  {#if section == 0}
		<h1>Hey Cutie!</h1>
  
		<p>
		  Let's get started on making skincare <strong>Cathartic!</strong>
		</p>
		<p>
		  You're about 3 minutes away from the best skin of your life
		</p>
  
		<button on:click={() => section++}>
		  Let's get Started!
		</button>
	  {:else if section == 1}
		<TierQuiz on:complete={() => section++} />
	  {:else if section == 2}
		<ProductQuiz on:complete={() => section++} />
	  {:else if section == 3}
		<button on:click={() => section++}>
		  See my results
		</button>
	  {:else if section == 4}
		<h1>This skincare is made for you!</h1>
  
		<p>
		  We recommend the following:
		</p>
  
		{#each results as result}
		  <a href="{result.url}">{result.name}</a>
		{/each}
  
		<p>
			If you buy now with the code DISCOUNT15 you'll get 15% off, free shipping, and a 30-day money back guarantee!
		</p>
		<p>
		  Taking care of your skin is a big step towards taking care of yourself.
		</p>
		<p>
		  Plus! Purchasing Catharsis Co. skincare products helps skincare science
		  and women everywhere.
		</p>
		<button on:click={() => startNewSession()}>
			Take The Quiz Again
		</button>
	  {/if}
	</div>
  
	<Image
	  src='/images/side_image.jpg'
	  alt='All of the products for the company.'
	  class='side-image'
	/>
  </main>
  
  <footer>
	<Image
	  src='/images/transparent-logo.png'
	  alt='Catharsis Skincare Co logo depicting the letter C surrounded by a laurel.'
	/>
  </footer>
  {/if}
  
  <style>
	main {
	  display: flex;
	  padding-top: 50px;
	  width: 100%;
	  margin-top: 6em;
	}
  
	footer {
	  text-align: center;
	  width: 100%;
	  max-width: 200px;
	  margin: 50px auto;
	}
  
	div {
	  display: flex;
	  flex-direction: column;
	  flex: 1 1 0%;
	  justify-content: center;
	  text-align: center;
	}
  
	button:hover {
		transform: scale(105%);
	}
  
	p {
	  font-weight: bold;
	}
	.container-quiz-attempt {
	  flex: none;
	}
	.container-content {
		padding-top: 6em;
	}
  </style>
  